import { rulesName } from './fields/rules-name'
import { rulesEmail } from './fields/rules-email'
import { rulesPhoneRequired } from './fields/rules-phone'

const rules = {
  name: rulesName,
  email: rulesEmail,
  phone: rulesPhoneRequired,
}

export { rules }
